import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Asset} from '../../../shared/view-model/store-management/asset.type';
import {Barcode} from '../../../identity/model/barcode.interface';
import {StockItem} from '../../../shared/view-model/store-management/stock-item.type';
import {VisbosService} from '../../../core/visbos-core/graphql/visbos.service';
import gql from 'graphql-tag';
import {Apollo} from 'apollo-angular';
import {IAppState} from '../../../shared/redux-store';
import {SessionActions} from '../../../shared/actions';
import {NgRedux} from '@angular-redux/store';
import {AssetTree} from '../../../shared/view-model/store-management/asset-tree.type';
import {TreeNode} from 'primeng/api';
import * as _ from 'lodash';

export type Data = {
  article: StockItem,
  assets: Asset[]
}

const itemMarriageMutation = gql`
  mutation ItemMarriage(
    $parentAssetCuid: ID!
    $childrenAssetCuids: [ID]!
    $sealEpc: String
  ) {
    marryAssets(
      parentAssetCuid: $parentAssetCuid
      childrenAssetCuids: $childrenAssetCuids
      sealEpc: $sealEpc
    ) {
      cuid
      label
      identities {
        cuid
        ean
        label
      }
      seals {
        cuid
        ean
        is_seal
        label
      }
      descendants {
        cuid
        label
      }
    }
  }
`

@Injectable()
export class MarriageService extends VisbosService {

  private _currentParentAsset: BehaviorSubject<Asset> = new BehaviorSubject(null);
  private _currentSeal: BehaviorSubject<Barcode> = new BehaviorSubject(null);

  public lastEpcs: string[] = [];
  public childrenAssetTree: BehaviorSubject<TreeNode[]> = new BehaviorSubject(<AssetTree[]>[]);


  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  getCurrentParentAsset(): BehaviorSubject<Asset> {
    return this._currentParentAsset;
  }

  setCurrentParentAsset(asset: Asset) {
    this._currentParentAsset.next(asset);
  }

  getCurrentSeal(): BehaviorSubject<Barcode> {
    return this._currentSeal;
  }

  setCurrentSeal(value: Barcode) {
    this._currentSeal.next(value);
  }

  reset() {
    this.setCurrentParentAsset(null);
    this.setCurrentSeal(null);
    this.updateAssetTree([]);
  }

  updateAssetTree(assetTree: AssetTree[]) {
    this.childrenAssetTree.next(_.cloneDeep(assetTree));
  }

  getChildrenAssetsList() {
    return this.childrenAssetTree.value;
  }

  getCurrentChildrenCuids() {
    return this.childrenAssetTree.value.map((treeNode: AssetTree) => treeNode.cuid);
  }

  saveCurrentMarriage() {
    return this.mutate({
      mutation: itemMarriageMutation,
      variables: {
        parentAssetCuid: this.getCurrentParentAsset().getValue().cuid,
        childrenAssetCuids: this.getCurrentChildrenCuids(),
        sealEpc: this.getCurrentSeal().getValue() ? this.getCurrentSeal().getValue().ean : null
      },
      //refetchQueries: ['LoadVehicleStock']
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/services/marriage.service.ts